import React, { useEffect } from 'react'
import { useContext } from 'react'
import { useState } from 'react'
import { createContext } from 'react'
const ShoppingCardContext = createContext({})
const initialCardItems = localStorage.getItem("shopping-cart")
  ? JSON.parse(localStorage.getItem("shopping-cart"))
  : [];

 const ShoppingCardProvider = ({children}) => {
    const [cardItems,setCardItems] = useState(initialCardItems)
    
    useEffect(() => {
      localStorage.setItem("shopping-cart", JSON.stringify(cardItems));
    }, [cardItems]);
  
    const GetItemsQuantity =(id)=> {
        return cardItems.find((item)=>item.id === id  )?.quantity || 0
    }
    const increaseCardQuantity = (id,dimension) => {
        setCardItems((currItems) => {
          if (currItems.find((item) => item.id === id) == null) {
            return [...currItems];
          } else {
            return currItems.map((item) => {
              if (item.id === id && item.dimension === dimension) {
                return { ...item, quantity: item.quantity + 1  };
              } else {
                return item;
              }
            });
          }
        });
      };
      const addItem = (newItem,dimension2,dimension,price, quantity) => {
          setCardItems((currItems) => {
            if (currItems.find((item) => item.id === newItem.id && item.dimension === dimension) == null ) {
              return [...currItems, { ...newItem,dimension2,dimension,price, quantity: parseInt(quantity) }];
            } else {
              return currItems.map((item) => {
                if (item.id === newItem.id && item.dimension === dimension) {
                  return { ...item ,dimension2,dimension,price, quantity: parseInt(item.quantity) + parseInt(quantity) };
                } 
                
                else {
                  return item;
                }
              });
            }
          });
        };
      const decreaseCardQuantity = (id,dimension) => {
        setCardItems((currItems) => {
          if (currItems.find((item) => item.id === id && item.dimension === dimension)?.quantity === 1) {
            return currItems.filter((item) => item.id !== id || item.dimension !== dimension  );
          } else {
            return currItems.map((item) => {
              if (item.id === id && item.dimension === dimension) {
                return { ...item, quantity: item.quantity - 1  };
              } else {
                return item;
              }
            });
          }
        });
      };
      const removeFromCard = (id,dimension) => {
        setCardItems((currItems) =>currItems.filter((item) => item.id !== id ||item.dimension !== dimension    ));
      };
  return (
    <ShoppingCardContext.Provider value={{
        cardItems ,
        removeFromCard,
        decreaseCardQuantity,
        increaseCardQuantity,
        GetItemsQuantity,
        addItem,
        initialCardItems,
        setCardItems
        }}>
        {children}
        </ShoppingCardContext.Provider>
  )
}
export const useShoppingCard =()=>{
return useContext(ShoppingCardContext)

}

export default ShoppingCardProvider
